import Link from "next/link";
import { getGlobalData } from "utils/api";
import { CMSUrls } from "utils/cmsHelper";
import { ContactBox } from "utils/constants";
import { getLocalizedPaths } from "utils/localize";

import Breadcrumb from "@/components/brandRefresh/common/Breadcrumb";
import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";

export default function ReportFraud({ metadata }) {
  return (
    <RefreshHeader metadata={metadata}>
      <div className="flex flex-col gap-[72px] text-sm md:text-base 4xl:text-xl">
        <Breadcrumb />
        <div className="flex flex-col gap-4 items-start">
          <h3 className="text-onmoText text-xl md:text-2xl 4xl:text-3xl font-medium mb-4">
            Contact us to report suspicious activity
          </h3>
          <p>
            Has your Card been lost or stolen? Don&apos;t recognise a
            transaction on your bank account or haven&apos;t opened an account
            with us? If you think you may have become a victim of fraud, get in
            touch. Our dedicated Team is here to help.
          </p>
          <div className="mt-6">
            <ul className="list-disc pl-6">
              <li>
                In order for us to investigate this, we require the following{" "}
                <Link
                  className="text-onmoPrimary underline"
                  href={CMSUrls.fraudentForm}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  form{" "}
                </Link>{" "}
                {"  "} to be filled in and completed.
              </li>
              <li>
                Once completed, please return this to us by attaching it to an
                email and sending it to FraudSupport@onmo.app
              </li>
              <li>Alternatively, you can mail the form to us.</li>
            </ul>
          </div>
          <p className="mt-6">
            Once received we will aim to complete our investigation and provide
            an outcome within 10 working days.
          </p>
        </div>
        <ContactBox email="help@onmo.app" />
      </div>
    </RefreshHeader>
  );
}

export async function getServerSideProps(context) {
  const { locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `How to report Fraud`,
  };

  return {
    props: {
      metadata,
      global: globalLocale.data,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}
